import { z } from "zod"

// Amplify Configuration Schema
export const amplifyEnvSchema = z.object({
  VITE_AWS_REGION: z.string().min(1, "AWS Region is required"),
  VITE_COGNITO_USER_POOL_ID: z
    .string()
    .min(1, "Cognito User Pool ID is required"),
  VITE_COGNITO_CLIENT_ID: z.string().min(1, "Cognito Client ID is required"),
})

// API Configuration Schema
export const apiEnvSchema = z.object({
  VITE_API_URL: z
    .string()
    .min(1, "API URL is required")
})

// CloudFront and Website URL Schema
export const urlEnvSchema = z.object({
  VITE_CLOUDFRONT_URL: z.string().optional(),
  VITE_WEBSITE_URL: z.string().optional(),
  VITE_HOSTED_ZONE_NAME: z.string().optional(),
})

// Validate Amplify environment variables at runtime
const amplifyParseResult = amplifyEnvSchema.safeParse({
  VITE_AWS_REGION: import.meta.env.VITE_AWS_REGION,
  VITE_COGNITO_USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  VITE_COGNITO_CLIENT_ID: import.meta.env.VITE_COGNITO_CLIENT_ID,
})

// Validate API environment variables at runtime
const apiParseResult = apiEnvSchema.safeParse({
  VITE_API_URL: import.meta.env.VITE_API_URL,
})

// Parse CloudFront and Website URL environment variables
const urlParseResult = urlEnvSchema.safeParse({
  VITE_CLOUDFRONT_URL: import.meta.env.VITE_CLOUDFRONT_URL || 'da5tspnozu0py.cloudfront.net',
  VITE_WEBSITE_URL: import.meta.env.VITE_WEBSITE_URL || 'https://cv-automation-demo.dev.scvl.jp',
  VITE_HOSTED_ZONE_NAME: import.meta.env.VITE_HOSTED_ZONE_NAME || 'cv-automation-demo.dev.scvl.jp',
})

if (!amplifyParseResult.success) {
  throw new Error(
    `Invalid Amplify configuration:\n${amplifyParseResult.error.issues.map((err) => err.message).join("\n")}`,
  )
}

// Application configuration object
export const config = {
  amplify: {
    Auth: {
      region: amplifyParseResult.data.VITE_AWS_REGION,
      userPoolId: amplifyParseResult.data.VITE_COGNITO_USER_POOL_ID,
      userPoolWebClientId: amplifyParseResult.data.VITE_COGNITO_CLIENT_ID,
    },
  },
  api: {
    baseUrl: apiParseResult.success
      ? apiParseResult.data.VITE_API_URL
      : "http://localhost:8080",
  },
  urls: {
    cloudfront: urlParseResult.success 
      ? urlParseResult.data.VITE_CLOUDFRONT_URL 
      : "da5tspnozu0py.cloudfront.net",
    website: urlParseResult.success 
      ? urlParseResult.data.VITE_WEBSITE_URL 
      : "https://cv-automation-demo.dev.scvl.jp",
    hostedZone: urlParseResult.success 
      ? urlParseResult.data.VITE_HOSTED_ZONE_NAME 
      : "cv-automation-demo.dev.scvl.jp",
  }
} as const

// Type for the config object
export type AppConfig = typeof config
